import { Tabs, TabsList, TabsTrigger, TabsContent } from '@radix-ui/react-tabs';
import React, { useEffect, useState, useRef } from 'react';
import { Link, useNavigate, useParams } from 'react-router-dom';
import { HTTP } from '../api/http-common';
import Swal from "sweetalert2";
import { SearchIcon } from "lucide-react";
import { X } from "lucide-react";

const EventEdit = () => {
    const { id } = useParams();
    const eventId = Number(id);

    const navigate = useNavigate();
    const access_token = (localStorage.getItem('access_token'));

    const [isEditable, setIsEditable] = useState(false);
    const [isLoading, setIsLoading] = useState(false);
    const [error, setError] = useState(null);
    const [searchValue, setSearchValue] = useState('');
    const [filterType, setFilterType] = useState("all");
    const [imageError, setImageError] = useState("");
    const [imagePreview, setImagePreview] = useState(null);
    const [titleError, setTitleError] = useState("");
    const [eventIdError, setEventIdError] = useState("");
    const [descriptionError, setDescriptionError] = useState("");
    const [startdateError, setStartDateError] = useState("");
    // const [enddateError, setEndDateError] = useState("");
    const [starttimeError, setStartTimeError] = useState("");
    const [endtimeError, setEndTimeError] = useState("");
    // const [tagError, setTagError] = useState("");
    const [urlError, setUrlError] = useState("");
    const [pagination, setPagination] = useState({ page: '1', limit: '100' });
    const [fileError, setFileError] = useState("");

    // For Adress
    const [addressError, setAddressError] = useState("");
    const [cityError, setCityError] = useState("");
    const [eventError, setEventError] = useState("");
    const [stateError, setStateError] = useState("");
    const [postalcodeError, setPostalcodeError] = useState("");
    const [longitudeError, setLongitudeError] = useState("");
    const [latitudeError, setLatitudeError] = useState("");

    const [formData, setFormData] = useState({
        eventid: "",
        title: "",
        description: "",
        start_date: "",
        // end_date: "",
        start_time: "",
        end_time: "",
        price: "",
        // tag: "",
        event_url: "",
        image: "",
        address: "",
        city_id: "",
        state: "",
        postal_code: "",
        latitude: "",
        longitude: "",
    });
    const fileInputRef = useRef(null);
    const [cityList, setcityList] = useState([]);
    const [eventList, seteventList] = useState([]);

    const fetchEventDetails = async () => {
        let config = {
            headers: { 'Content-Type': 'application/json', 'token': access_token },
        };

        try {
            const response = await HTTP.get(`/user/event/${eventId}`, formData, config);

            if (response.status === 200) {
                const eventMain = response.data; // No need for `contents`

                setFormData({
                    id: eventMain.id,
                    eventid: eventMain.eventid || "",
                    title: eventMain.title || "",
                    description: eventMain.description || "",
                    start_date: eventMain.start_date || "",
                    // end_date: eventMain.end_date || "",
                    start_time: eventMain.start_time || "",
                    end_time: eventMain.end_time || "",
                    image: eventMain.image || "",
                    price: eventMain.price || "",
                    event_url: eventMain.event_url || "",
                    address: eventMain.address || "",
                    city_id: eventMain.city_id || "",
                    state: eventMain.state || "",
                    postal_code: eventMain.postal_code || "",
                    latitude: eventMain.latitude || "",
                    longitude: eventMain.longitude || "",
                });
            }
        } catch (error) {
            console.log("error", error);
        }
    };


    useEffect(() => {
        if (eventId) {
            fetchEventDetails();
        }
    }, [eventId]); // Re-fetch data when eventId changes

    // Handle filter change
    const handleFilterChange = (e) => {
        const newFilter = e.target.value;
        setFilterType(newFilter);
    };

    // Handle search enter
    const onSearchEnter = (value) => {
        setSearchValue(value);
        fetchEventDetails(filterType, value); // Keep current filter while searching
    };

    const handleEditToggle = () => {
        setIsEditable(prevState => !prevState);
    };

    const handleImageChange = (e) => {
        const file = e.target.files[0];
        if (file) {
            const reader = new FileReader();
            reader.onloadend = () => {
                setFormData((prev) => ({
                    ...prev,
                    image: reader.result, // Convert to base64 preview
                }));
                setImageError(""); // Clear error when image is uploaded
            };
            reader.readAsDataURL(file);
        }
    };

    const handleDeleteBannerImage = () => {
        setFormData((prev) => ({
            ...prev,
            image: "",
        }));
        setImageError("Please upload an event image."); // Show validation error
    };

    const handleChange = (e) => {
        const { name, value, type, checked, files } = e.target;
        if (name === "image") {
            const file = files[0]; // Get the selected file
            if (file) {
                // Generate a preview URL using FileReader
                const reader = new FileReader();
                reader.onloadend = () => {
                    setImagePreview(reader.result); // Set preview URL
                    setFormData({ ...formData, image: file }); // Set the file in formData
                };
                reader.readAsDataURL(file); // Convert file to base64 string
            }
        }

        else {
            setFormData((prevData) => ({
                ...prevData, // ✅ Correctly spreading the object
                [name]: type === "checkbox" ? checked : value, // ✅ Updating the correct field
            }));
        }
    };

    const fetchCities = async () => {
        try {
            const access_token = localStorage.getItem('access_token');
            const config = {
                headers: { "Content-Type": "application/json", token: access_token },
            };

            const response = await HTTP.post("vendors_address/city", config);

            if (response.status === 200) {
                setcityList(response.data);
            }
        } catch (error) {
            console.error("Error fetching cities:", error);
        }
    };


    useEffect(() => {
        fetchCities();
    }, []);

    const resetValidationErrors = () => {
        setEventIdError('');
        setTitleError('');
        setDescriptionError('');
        setStartDateError('');
        // setEndDateError('');
        setStartTimeError('');
        setEndTimeError('');
        setUrlError('');
        // setPriceError('');
        // setTagError('');
        setAddressError('');
        setCityError('');
        setStateError('');
        setPostalcodeError('');
        setLatitudeError('');
        setLongitudeError('');
        setImageError('');
    };

    const validateField = () => {
        resetValidationErrors();
        let checked = true;
        // Event ID Validation
        if (!formData.eventid.trim()) {
            setEventIdError('Please enter an event ID');
            checked = false;
        }

        // Title Validation
        if (!formData.title.trim()) {
            setTitleError('Please enter a title');
            checked = false;
        } else if (formData.title.length < 5) {
            setTitleError("Title must be at least 5 characters");
            checked = false;
        } else if (formData.title.length > 100) {
            setTitleError("Title must not exceed 100 characters");
            checked = false;
        }

        // Description Validation
        if (!formData.description.trim()) {
            setDescriptionError('Please enter a description');
            checked = false;
        } else if (formData.description.length < 5) {
            setDescriptionError("Description must be at least 5 characters");
            checked = false;
        } else {
            setDescriptionError(""); // Clear error if validation passes
        }


        // Start Date Validation
        if (!formData.start_date) {
            setStartDateError("Please enter a start date");
            checked = false;
        }

        // End Date Validation
        // if (!formData.end_date) {
        //   setEndDateError("Please enter an end date");
        //   checked = false;
        // } else if (formData.start_date && formData.end_date < formData.start_date) {
        //   setEndDateError("End date must be after start date");
        //   checked = false;
        // }

        // Start Time Validation
        if (!formData.start_time) {
            setStartTimeError("Please enter a start time");
            checked = false;
        }

        // End Time Validation
        if (!formData.end_time) {
            setEndTimeError("Please enter an end time");
            checked = false;
        } else if (formData.start_time && formData.end_time <= formData.start_time) {
            setEndTimeError("End time must be after start time");
            checked = false;
        }

        // Price Validation
        // if (!formData.price) {
        //   setPriceError("Please enter an entry price");
        //   checked = false;
        // } else if (isNaN(formData.price) || formData.price < 0) {
        //   setPriceError("Price must be a valid non-negative number");
        //   checked = false;
        // }
        if (formData.event_url.trim()) {
            const urlPattern = /^(https?:\/\/)?([\w-]+\.)+[\w-]{2,}(\/.*)?$/;
            if (!urlPattern.test(formData.event_url.trim())) {
                setUrlError("Please enter a valid URL (e.g., https://example.com)");
                checked = false;
            }
        }

        // Address Validation
        if (!formData.address.trim()) {
            setAddressError("Please enter an address");
            checked = false;
        }

        // City Validation
        if (!formData.city_id) {
            setCityError("Please select a city");
            checked = false;
        }

        // State Validation
        if (!formData.state.trim()) {
            setStateError("Please enter a state");
            checked = false;
        }

        // Postal Code Validation
        if (!formData.postal_code.trim()) {
            setPostalcodeError("Please enter a postal code");
            checked = false;
        } else if (!/^\d{5,6}$/.test(formData.postal_code)) {
            setPostalcodeError("Enter a valid postal code (5-6 digits)");
            checked = false;
        }

        // Latitude Validation
        if (!String(formData.latitude).trim()) {
            setLatitudeError("Please enter latitude");
            checked = false;
        } else if (isNaN(formData.latitude) || formData.latitude < -90 || formData.latitude > 90) {
            setLatitudeError("Enter a valid latitude (-90 to 90)");
            checked = false;
        }


        // Longitude Validation
        if (!String(formData.longitude).trim()) {
            setLongitudeError("Please enter longitude");
            checked = false;
        } else if (isNaN(formData.longitude) || formData.longitude < -180 || formData.longitude > 180) {
            setLongitudeError("Enter a valid longitude (-180 to 180)");
            checked = false;
        }

        // Image Validation
        if (!formData.image) {
            setImageError("Please upload an event image");
            checked = false;
        }

        return checked;
    };
    const handleSubmit = async (e) => {
        e.preventDefault();
        const Id = eventId;
        setIsLoading(true);
        setError(null);

        if (!validateField()) {
            return; // Stop submission if validation fails
        }
        try {
            const formDataObj = new FormData();

            // Append all form fields except the image
            Object.keys(formData).forEach((key) => {
                if (key !== "image" && formData[key]) {
                    formDataObj.append(key, formData[key]);
                }
            });

            // Append file if selected, otherwise keep existing image URL
            // if (fileInputRef.current?.files.length > 0) {
            //     formDataObj.append("image", fileInputRef.current.files[0]);
            // } else if (formData.image) {
            //     formDataObj.append("image", formData.image);
            // }

            // Append file if selected, otherwise keep existing image URL
            if (fileInputRef.current?.files.length > 0) {
                formDataObj.append("image", fileInputRef.current.files[0]); // Append only if new file selected
            }

            const response = await HTTP.put(`/user/event_update/${Id}`, formDataObj, {
                headers: {
                    "Content-Type": "multipart/form-data",
                    token: access_token,
                },
            });

            if (response.status === 200) {
                Swal.fire({
                    icon: "success",
                    title: "Success!",
                    text: "Event Updated Successfully",
                });
                navigate("/events");
            }
        } catch (error) {
            console.error("Error updating event:", error);
            setError("Failed to update event. Please try again.");
        } finally {
            setIsLoading(false);
        }
    };


    return (
        <>
            <div className="container mx-auto p-2 md:p-8 ">
                <form className="space-y-4 mt-8" onSubmit={handleSubmit} >

                    <div className="bg-white rounded-lg p-6 border-gray-200 border">
                        <h3 className="font-medium text-lg mb-4">Info</h3>
                        <div className="grid grid-cols-2 gap-4">
                            <div className="space-y-2">
                                <label htmlFor="eventid" className="text-sm font-medium">
                                Event ID
                                </label>
                                <input
                                type="text"
                                id="eventid"
                                name="eventid"
                                className="peer w-full focus:outline-none focus:border-b focus:border-gray-400 placeholder:text-gray-400 peer h-10 px-0 bg-transparent border-0 border-b input-border-bottom rounded-none focus-visible:ring-0 focus-visible:border-gray-400"
                                value={formData.eventid}
                                onChange={handleChange}
                                />
                                {eventIdError && <span className="text-sm text-red-500">{eventIdError}</span>}
                            </div>
                            <div className="space-y-2">
                                <label htmlFor="title" className="text-sm font-medium">
                                    Title
                                </label>
                                <input
                                    type="text"
                                    id="title"
                                    name="title"
                                    className="peer w-full focus:outline-none focus:border-b focus:border-gray-400 placeholder:text-gray-400 peer h-10 px-0 bg-transparent border-0 border-b input-border-bottom rounded-none focus-visible:ring-0 focus-visible:border-gray-400"
                                    value={formData.title}
                                    onChange={handleChange}
                                />
                                {titleError && <span className="text-sm text-red-500">{titleError}</span>}
                            </div>

                            {/* Start Date */}
                            <div className="space-y-2">
                                <label htmlFor="start_date" className="text-sm font-medium">
                                    Start Date
                                </label>
                                <input
                                    type="date"
                                    id="start_date"
                                    name="start_date"
                                    className="peer w-full focus:outline-none focus:border-b focus:border-gray-400 placeholder:text-gray-400 peer h-10 px-0 bg-transparent border-0 border-b input-border-bottom rounded-none focus-visible:ring-0 focus-visible:border-gray-400"
                                    value={formData.start_date}
                                    onChange={handleChange}
                                />
                                {startdateError && <span className="text-sm text-red-500">{startdateError}</span>}
                            </div>

                            {/* End Date */}
                            {/* <div className="space-y-2">
                                        <label htmlFor="end_date" className="text-sm font-medium">
                                            End Date
                                        </label>
                                        <input
                                            type="date"
                                            id="end_date"
                                            name="end_date"
                                            className="peer w-full focus:outline-none focus:border-b focus:border-gray-400 placeholder:text-gray-400 peer h-10 px-0 bg-transparent border-0 border-b input-border-bottom rounded-none focus-visible:ring-0 focus-visible:border-gray-400"
                                            value={formData.end_date}
                                            onChange={handleChange}
                                        />
                                        {enddateError && <span className="text-sm text-red-500">{enddateError}</span>}
                                        </div> */}

                            {/* Start Time */}
                            <div className="space-y-2">
                                <label htmlFor="start_time" className="text-sm font-medium">
                                    Start Time
                                </label>
                                <input
                                    type="time"
                                    id="start_time"
                                    name="start_time"
                                    className="peer w-full focus:outline-none focus:border-b focus:border-gray-400 placeholder:text-gray-400 peer h-10 px-0 bg-transparent border-0 border-b input-border-bottom rounded-none focus-visible:ring-0 focus-visible:border-gray-400"
                                    value={formData.start_time}
                                    onChange={handleChange}
                                />
                                {starttimeError && <span className="text-sm text-red-500">{starttimeError}</span>}
                            </div>

                            {/* End Time */}
                            <div className="space-y-2">
                                <label htmlFor="end_time" className="text-sm font-medium">
                                    End Time
                                </label>
                                <input
                                    type="time"
                                    id="end_time"
                                    name="end_time"
                                    className="peer w-full focus:outline-none focus:border-b focus:border-gray-400 placeholder:text-gray-400 peer h-10 px-0 bg-transparent border-0 border-b input-border-bottom rounded-none focus-visible:ring-0 focus-visible:border-gray-400"
                                    value={formData.end_time}
                                    onChange={handleChange}
                                />
                                {endtimeError && <span className="text-sm text-red-500">{endtimeError}</span>}
                            </div>

                            {/* Event Url */}
                            <div className="space-y-2">
                                <label htmlFor="price" className="text-sm font-medium">
                                    Event Url
                                </label>
                                <input
                                    type="text"
                                    id="event_url"
                                    name="event_url"
                                    className="peer w-full focus:outline-none focus:border-b focus:border-gray-400 placeholder:text-gray-400 peer h-10 px-0 bg-transparent border-0 border-b input-border-bottom rounded-none focus-visible:ring-0 focus-visible:border-gray-400"
                                    value={formData.event_url}
                                    onChange={handleChange}
                                />
                                {urlError && <span className="text-sm text-red-500">{urlError}</span>}
                            </div>
                            <div className="space-y-2">
                                <label htmlFor="price" className="text-sm font-medium">
                                    Price
                                </label>
                                <input
                                    type="text"
                                    id="price"
                                    name="price"
                                    className="peer w-full focus:outline-none focus:border-b focus:border-gray-400 placeholder:text-gray-400 peer h-10 px-0 bg-transparent border-0 border-b input-border-bottom rounded-none focus-visible:ring-0 focus-visible:border-gray-400"
                                    value={formData.price}
                                    onChange={handleChange}
                                />
                                <p className="text-sm text-red-500">Leave blank for free</p>
                            </div>

                            {/* Address */}
                            <div className="space-y-2">
                                <label htmlFor="address" className="text-sm font-medium">
                                    Address
                                </label>
                                <input
                                    type="text"
                                    id="address"
                                    name="address"
                                    className="peer w-full focus:outline-none focus:border-b focus:border-gray-400 placeholder:text-gray-400 peer h-10 px-0 bg-transparent border-0 border-b input-border-bottom rounded-none focus-visible:ring-0 focus-visible:border-gray-400"
                                    value={formData.address}
                                    onChange={handleChange}
                                />
                                {addressError && <span className="text-sm text-red-500">{addressError}</span>}
                            </div>

                            {/* City */}
                            <div className="space-y-2">
                                <label htmlFor="city" className="text-sm font-medium">
                                    City
                                </label>
                                <select
                                    name="city_id"
                                    value={formData.city_id}
                                    onChange={handleChange}
                                    className="peer w-full focus:outline-none focus:border-b focus:border-gray-400 placeholder:text-gray-400 peer h-10 px-0 bg-transparent border-0 border-b input-border-bottom rounded-none focus-visible:ring-0 focus-visible:border-gray-400"
                                >
                                    <option value="">Select City</option>
                                    {Array.isArray(cityList) && cityList.length > 0
                                        ? cityList.map((city) => (
                                            <option key={city.id} value={city.id}>
                                                {city.name}
                                            </option>
                                        ))
                                        : <option value="">No cities available</option>}
                                </select>
                                {cityError && <span className="text-sm text-red-500">{cityError}</span>}

                            </div>

                            {/* State */}
                            <div className="space-y-2">
                                <label htmlFor="state" className="text-sm font-medium">
                                    State
                                </label>
                                <input
                                    type="text"
                                    id="state"
                                    name="state"
                                    className="peer w-full focus:outline-none focus:border-b focus:border-gray-400 placeholder:text-gray-400 peer h-10 px-0 bg-transparent border-0 border-b input-border-bottom rounded-none focus-visible:ring-0 focus-visible:border-gray-400"
                                    value={formData.state}
                                    onChange={handleChange}
                                />
                                {stateError && <span className="text-sm text-red-500">{stateError}</span>}
                            </div>

                            {/* Postal Code */}
                            <div className="space-y-2">
                                <label htmlFor="postal_code" className="text-sm font-medium">
                                    Postal Code
                                </label>
                                <input
                                    type="text"
                                    id="postal_code"
                                    name="postal_code"
                                    className="peer w-full focus:outline-none focus:border-b focus:border-gray-400 placeholder:text-gray-400 peer h-10 px-0 bg-transparent border-0 border-b input-border-bottom rounded-none focus-visible:ring-0 focus-visible:border-gray-400"
                                    value={formData.postal_code}
                                    onChange={handleChange}
                                />
                                {postalcodeError && <span className="text-sm text-red-500">{postalcodeError}</span>}
                            </div>

                            <div className="space-y-2">
                                <label htmlFor="latitude" className="text-sm font-medium">
                                    Latitude
                                </label>
                                <input
                                    type="text"
                                    id="latitude"
                                    name="latitude"
                                    className="peer w-full focus:outline-none focus:border-b focus:border-gray-400 placeholder:text-gray-400 peer h-10 px-0 bg-transparent border-0 border-b input-border-bottom rounded-none focus-visible:ring-0 focus-visible:border-gray-400"
                                    value={formData.latitude}
                                    onChange={handleChange}
                                />
                                {latitudeError && <span className="text-sm text-red-500">{latitudeError}</span>}
                            </div>

                            <div className="space-y-2">
                                <label htmlFor="longitude" className="text-sm font-medium">
                                    Longitude
                                </label>
                                <input
                                    type="text"
                                    id="longitude"
                                    name="longitude"
                                    className="peer w-full focus:outline-none focus:border-b focus:border-gray-400 placeholder:text-gray-400 peer h-10 px-0 bg-transparent border-0 border-b input-border-bottom rounded-none focus-visible:ring-0 focus-visible:border-gray-400"
                                    value={formData.longitude}
                                    onChange={handleChange}
                                />
                                {longitudeError && <span className="text-sm text-red-500">{longitudeError}</span>}
                            </div>

                            <div className="space-y-2">
                                <label htmlFor="file" className="text-sm font-medium">
                                    Event Image
                                </label>
                                <input
                                    type="file"
                                    id="image"
                                    name="image"
                                    className="peer w-full focus:outline-none focus:border-b focus:border-gray-400 placeholder:text-gray-400 peer h-10 px-0 bg-transparent border-0 border-b input-border-bottom rounded-none focus-visible:ring-0 focus-visible:border-gray-400"
                                    onChange={handleImageChange}
                                    ref={fileInputRef}
                                />
                                <p className="text-sm text-red-500">Image Only</p>
                                {imageError && <p className="text-sm text-red-500">{imageError}</p>}
                                {formData.image && (
                                    <div className="relative mt-2">
                                        <img
                                            src={formData.image}
                                            alt="Image Preview"
                                            className="upload-image"
                                        />
                                        <button
                                            className="absolute top-1 right-1 bg-red-500 text-white rounded-full p-1"
                                            onClick={handleDeleteBannerImage}
                                            type="button"
                                        >
                                            <X />
                                        </button>
                                    </div>
                                )}
                            </div>

                            <div className="space-y-2">
                                <label htmlFor="description" className="text-sm font-medium">
                                    Description
                                </label>
                                <textarea
                                    type=""
                                    id="description"
                                    name="description"
                                    className="w-full p-3 rounded-lg shadow-sm focus:outline-none focus:ring-2 focus:ring-blue-500"
                                    value={formData.description}
                                    onChange={handleChange}
                                />
                                {descriptionError && <span className="text-sm text-red-500">{descriptionError}</span>}
                            </div>

                        </div>
                    </div>

                    <button
                        type="submit"
                        className="theme-button text-white px-4 py-2 rounded-md border-gray-200 border"
                        style={{
                            backgroundColor: "#6c1cff",
                            cursor: "pointer",
                            opacity: 1,
                            marginBottom: "20px",
                        }}
                    >
                        Submit
                    </button>
                </form>

            </div>
        </>
        // <>This is Edit Vendor</>
    )
}

export default EventEdit